import { PLACEHOLDER_URL } from 'shared/consts/marketplace/orders'
import { Model } from 'shared/services/api/models/Model'
import { OrderDocumentPricePerUnit } from './orderDocumentPricePerUnit'
import { OrderDocumentPositionV1 } from './ordersResponseTypes'

export class OrderDocumentPosition extends Model {
  public readonly amountRedpoints: number
  public readonly availability: string
  public readonly canonicalURL: string
  public readonly isCoolingRequired: boolean
  public readonly lineNum: number
  public readonly pzn: string
  public readonly itemName: string
  public readonly quantity: number
  public readonly salesPrice: number
  public readonly lineDiscountPercent: number
  public readonly lineAmount: number
  public readonly itemTax: number
  public readonly prescriptionBonus: number
  public readonly packagingUnit: string
  public readonly packagingQuantity: number
  public readonly pharmaForm: string
  public readonly pricePerUnit: OrderDocumentPricePerUnit
  public readonly thumbnailURL: string
  public readonly upid: string

  constructor(src: OrderDocumentPositionV1) {
    super(src)
    this.amountRedpoints = src.amountRedpoints
    this.availability = src.availability
    this.canonicalURL = src.canonicalURL
    this.isCoolingRequired = Boolean(src.isCoolingRequired)
    this.lineNum = src.lineNum
    this.pzn = src.pzn
    this.itemName = src.itemName
    this.quantity = src.quantity
    this.salesPrice = src.salesPrice
    // TODO: Remove the percentage rounding when it is done by the service
    this.lineDiscountPercent = Math.round(src.lineDiscountPercent)
    this.lineAmount = src.lineAmount
    this.itemTax = src.itemTax
    this.prescriptionBonus = src.prescriptionBonus
    this.packagingUnit = src.packagingUnit
    this.packagingQuantity = src.packagingQuantity
    this.pharmaForm = src.pharmaForm
    if (src.pricePerUnit?.formatted) {
      this.pricePerUnit = new OrderDocumentPricePerUnit(src.pricePerUnit)
    }
    this.thumbnailURL = src.thumbnailURL || PLACEHOLDER_URL
    this.upid = src.upid
  }
}
